import { DetailSupportFormAnnounce6Container } from "../../../containers/SupportSystem/SupportForm/DetailSupportFormAnnounce6Container";
export function DetailSupportFormAnnounce6Page() {
    return (
        <DetailSupportFormAnnounce6Container />
    );

}